module.exports = __webpack_public_path__ + "static/media/sadcrying1.d90f5e94.png";